import React, { useEffect, useState, useRef } from "react";
import { CSVLink } from "react-csv";
import api from "../../services/api";
import { useNavigate } from "react-router";
import NoDataFound from "../../shared/NoDataFound";
import TableLoader from "../../shared/TableLoader";
import { SlIconButton } from "@shoelace-style/shoelace/dist/react";
import { roles } from "../../utils/constants";

function LineitemImageWise(props) {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const csvLinkRef = useRef();
  const isOps = localStorage.getItem("role") === roles.ops;

  let csvHeaders = [
    { label: "Creative Name", key: "creative_name" },
    { label: "Image Id", key: "img_id" },
  ];
  if (isOps) {
    csvHeaders.push({ label: "Adv Impressions", key: "adv_impressions" });
  }
  csvHeaders.push({ label: "Impressions", key: "impressions" });
  if (isOps) {
    csvHeaders.push({ label: "Adv Clicks", key: "adv_clicks" });
  }
  csvHeaders.push({ label: "Clicks", key: "clicks" });
  if (isOps) {
    csvHeaders.push({ label: "Adv CTR(%)", key: "adv_ctr" });
  }
  csvHeaders.push({ label: "CTR(%)", key: "ctr" });

  const getdata = async () => {
    setLoader(true);
    try {
      let res = await api({
        url: "/lineitems/lineitemResports",
        method: "POST",
        responseType: "json",
        data: {
          campaign_id: props.campaign_id,
          action: "imagewise",
          status: props.status,
        },
      });
      if (res.code === 200) {
        setData(res?.data?.images || []);
      }
      setLoader(false);
    } catch (error) {
      console.error(error);
      setLoader(false);
      if (error?.response?.status === 401) navigate("/");
    }
  };

  useEffect(() => {
    getdata();
  }, []);

  return (
    <>
      <div className="overflow-x-auto mb-4">
        <div className="d-flex justify-end pr-4">
          <CSVLink
            data={data || []}
            headers={csvHeaders}
            filename={`${props.campaign_name}_Image_wise.csv`}
            ref={csvLinkRef}
          ></CSVLink>
          <SlIconButton
            library="lucide"
            name="download"
            onClick={() => {
              csvLinkRef?.current?.link?.click();
            }}
          ></SlIconButton>
        </div>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th scope="col">Image</th>
              <th scope="col">Creative Name</th>
              {isOps && <th scope="col">Adv Impressions</th>}
              <th scope="col">Impressions</th>
              {isOps && <th scope="col">Adv Clicks</th>}
              <th scope="col">Clicks</th>
              {isOps && <th scope="col">Adv CTR(%)</th>}
              <th scope="col">CTR(%)</th>
            </tr>
          </thead>
          {data?.length && !loader ? (
            <tbody>
              {data.map((item, index) => (
                <tr key={index}>
                  <td>
                    {item.url ? (
                      <a href={item.url} target="_blank" rel="noreferrer">
                        <img
                          src={item.url}
                          alt={item.creative_name}
                          style={{ width: "60px", height: "60px", objectFit: "cover", borderRadius: "4px" }}
                        />
                      </a>
                    ) : (
                      "-"
                    )}
                  </td>
                  <td>{item.creative_name}</td>
                  {isOps && <td>{parseInt(item.adv_impressions || 0)}</td>}
                  <td>{parseInt(item.impressions || 0)}</td>
                  {isOps && <td>{parseInt(item.adv_clicks || 0)}</td>}
                  <td>{parseInt(item.clicks || 0)}</td>
                  {isOps && <td>{item.adv_ctr || 0}</td>}
                  <td>{item.ctr || 0}</td>
                </tr>
              ))}
            </tbody>
          ) : !data?.length && !loader ? (
            <NoDataFound colspan="8" />
          ) : (
            <TableLoader colspan="8" />
          )}
        </table>
      </div>
    </>
  );
}

export default LineitemImageWise;
